import { ShapeBaseAttribute } from './base';
export class ImageAttribute extends ShapeBaseAttribute {
  // parameter = 1000;
  /**
   * 秒针帧率
   *
   * @memberof ImageAttribute
   */
  pointerFps = 1;

  /**
   * 指南针帧率
   *
   * @memberof ImageAttribute
   */
  compassFps = 50;

  /**
   * 指针光源象限数量：0：不展示象限； 1：无象限，2：两象限 4：四象限
   *
   * @memberof ImageAttribute
   */
  pointerRegionNum = 0;
  shadowPointerOffsetY = 0;

  // 对应1.5 超出范围是否显示
  _hideWhenOutRange?: boolean;

  pivotX?: number;
  pivotY?: number;

  resources: {
    pointer0?: LayerResourceItem;
    pointer1?: LayerResourceItem;
    pointer2?: LayerResourceItem;
    pointer3?: LayerResourceItem;
    pointerShadow?: LayerResourceItem;
    /**
     * ifttt无数据时显示的图片
     */
    iftttEmptyImage?: LayerResourceItem;
  } = {};

  // 缩放
  scale?: number;
  // 透明度
  alpha?: number;

  // 指针超出范围是否显示
  renderRule?: 'alwaysShow' | 'hideWhenOutRange' | 'hideWhenUnitMismatch';

 // 是否单独设置缩放，判断是否跟随全局缩放
  isSetSingleScale?: boolean;

  /** 全局蒙层标记 */
  _maskFlag?: string;
  /** 蒙层图片像素透明度（0~1），按配色ID索引，用于 AOD 像素校验 */
  _maskPixelAlpha?: { [colorGroupId: string]: number };
}
